<template>
  <main>
    <div class="gp-main-body-content">
      <Modal :hideExit="true" cClass="mw424">
        <template #header>
          <p class="typo-heading20 typo-medium text-light-high">Reset Password</p>
        </template>
        <template #default>
          <form ref="form" @submit.prevent="agencyLogin">
            <div class="form-group">
              <label class="label typo-button14 typo-medium text-light-high">{{ $t("agency.newPassword") }}</label>
              <input class="input-field input-field-block" :class="{ 'is-error': errorText && errorText.length }" type="password" required v-focus :title="$t('generals.password')" :placeholder="$t('generals.password')" v-model="password" />
              <!-- <p v-if="alertText" class="typo-paragraph12 typo-italic text-danger mt-half">{{ alertText }}</p> -->
            </div>
            <div class="form-group">
              <label class="label typo-button14 typo-medium text-light-high">{{ $t("agency.confirmPassword") }}</label>
              <input class="input-field input-field-block" :class="{ 'is-error': errorText && errorText.length }" type="password" required :title="$t('generals.password')" :placeholder="$t('generals.password')" v-model="passwordConfirm" />
            </div>
            <p v-if="errorText" class="typo-paragraph12 typo-italic text-danger mt-half">{{ errorText }}</p>

            <div class="btn-group flex-row-reverse make-default-btn mt-4">
              <ProcessButton class="btn btn-primary btn-block btn-default" type="submit" :status.sync="btnStatus">
                <template #loading>Changing ...</template>
                <template #success>{{ $t("generals.success") }}</template>
                <template #error>Failed</template>
                <template #default>{{ $t("agency.changePwd") }}</template>
              </ProcessButton>
            </div>
          </form>
        </template>
      </Modal>
    </div>

    <PortalTarget name="modals" multiple></PortalTarget>
  </main>
</template>

<script>
import { Api, ApiUrl } from "@/services";
import ProcessButton from "@/core/shared/ProcessButton.vue";

export default {
  name: "AgencyReset",
  components: {
    ProcessButton
  },
  data() {
    return {
      password: "",
      passwordConfirm: "",
      btnStatus: {
        success: false,
        loading: false,
        error: false
      },
      token: "",
      errorType: ""
    };
  },
  computed: {
    errorText() {
      const type = this.errorType;
      if (!type || !type.length) {
        return null;
      }
      return this.getErrorText(type);
    }
  },

  created() {
    this.initCheck();
  },
  mounted() {},
  methods: {
    getErrorText(type) {
      switch (type) {
        case "password_confirmation":
        case "reset_password_token":
          return this.$t(`error.${type}`);
        default:
          return this.$t("error.unknown");
      }
    },
    initCheck() {
      const query = this.$route.query;
      if (query && query.reset_password_token) {
        this.token = query.reset_password_token;
      }

      if (!this.token || !this.token.length) {
        this.$router.push({ name: "GlobalError", params: { type: "link_expired" }, meta: { disclaimer: false } });
        return false;
      }

      return true;
    },
    agencyLogin() {
      this.errorType = "";
      if (this.passwordConfirm != this.password) {
        this.errorType = "password_confirmation";
        return false;
      }
      this.btnStatus.loading = true;

      let data = {
        agency: {
          password: this.password,
          password_confirmation: this.passwordConfirm,
          reset_password_token: this.token
        }
      };
      Api.base
        .put(ApiUrl.base.agency.resetPassword, data)
        .then(res => {
          if (res.data.status == "success") {
            this.btnStatus.success = true;
            window.location.href = res.data.location;
            this.timeout = setTimeout(() => {
              this.btnStatus.success = false;
            }, 1500);
          } else {
            throw new Error(res);
          }
        })
        .catch(err => {
          this.errorType = (err.response && err.response.data && err.response.data.data.message) || "network";
          this.btnStatus.error = true;
          this.timeout = setTimeout(() => {
            this.btnStatus.error = false;
          }, 1500);
        })
        .finally(() => {
          this.btnStatus.loading = false;
        });
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.initCheck(to);
      // if (vm.initCheck(to)) {
      //   return true;
      // }
      return true;
    });
  }
};
</script>

<style lang="scss" scoped></style>
